import lozad from 'lozad';
import { header } from '../index/scripts/header';
$(document).ready(function () {
	header.init();
	handleAjaxPortfolio();
});
/*==================== Lazyload JS ====================*/
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();
/*==================== Ajax ====================*/
function handleAjaxPortfolio() {
	const wrapBox = $('.section-portfolio-canhcam-ajax');
	// change section-portfolio-canhcam-ajax
	function processAjax(pageUrl) {
		$.ajax({
			type: 'GET',
			url: pageUrl,
			dataType: 'html',
			beforeSend: function () {
				$('.loading-ajax').addClass('active');
			},
			success: function (data) {
				const isHasPortfolio = $(data).find(
					'.section-portfolio-canhcam-ajax'
				).length;
				if (isHasPortfolio) {
					wrapBox.html($(data).find('.section-portfolio-canhcam-ajax').html());
				} else {
					wrapBox.html('');
				}
			},
			complete: function (data) {
				$('.loading-ajax').removeClass('active');
				if (pageUrl != window.location) {
					window.history.pushState({ path: pageUrl }, '', pageUrl);
				}
				observer.observe();
			},
		});
	}
	$('body').on(
		'click',
		'.section-portfolio-canhcam .tabs-list-secondary li a',
		function (e) {
			e.preventDefault();
			const linkUrl = $(this).attr('href');
			$(this).parent().addClass('active').siblings().removeClass('active');
			processAjax(linkUrl);
		}
	);
}
